import { FC, PropsWithChildren } from 'react';
import { formLayoutPaddingTop } from './FormLayout.styles';
import Box from 'yoda-ui/components/Box';

const FormLayoutMidPanel: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      flex="grow"
      flexGrow={ 1 }
      paddingTop={ formLayoutPaddingTop }
    >
      { children }
    </Box>
  );
};

export default FormLayoutMidPanel;
